import { createSlice, createEntityAdapter } from '@reduxjs/toolkit'
import actionFactory from 'Shared/hooks/actionFactory'

const adapter = createEntityAdapter()

const reducer = createSlice({
  name: 'dashboardTargets',
  initialState: adapter.getInitialState(),
  reducers: {
    upsert: adapter.upsertOne,
    add: adapter.addOne,
    set: adapter.setOne,
    setAll: adapter.setAll
  },
}).reducer

const actions = (dis, store, restClient) => {
  const factoryActions = actionFactory(dis, store, 'dashboardTarget', {}, {

  })

  return {
    ...factoryActions,
  }
}

export { reducer, actions }
export default { reducer, actions }
